/**
 * Collection of design tokens for color transparency levels. Unlike the opacities tokens, these
 * specifically affect the alpha channel of a color.
 */ const colorAlphas = {
    weakest: 0.02,
    weaker: 0.04,
    weak: 0.12,
    medium: 0.16,
    strong: 0.24,
    stronger: 0.32
};

export { colorAlphas };
//# sourceMappingURL=color-alphas.js.map
